import React from 'react';
import {Link} from "@reach/router";

const PODLogo = ({ className }) => {
  return (
    <div className={`logo intro-logo ${className ? className : ''}`}>
      <Link to={'/'}><img src="/images/v2/logo.svg" alt="PayOnDelivery" className="intro-logo-img" /></Link>
    </div>
  );
}

export default PODLogo;
